import { Modal } from "components";
import React from "react";
import VatRateList from "components/Picker/VatRatePicker/VatRateList";

interface Props {
  addVatRate: (vatRate: server.dto.VatRate) => void;
  onClose: () => void;
  activeVatRates: server.dto.VatRate[]
}
const VatRatesAddModal = (props: Props) => {
  return <Modal
    isOpen
    handleClose={props.onClose}
    title="Add VAT rate"
    size="mini"
    height={500}
    gap="regular"
  >
    <VatRateList
      onItemSelected={props.addVatRate}
      excludeKeys={props.activeVatRates.map(v => v.vatRateId)}
    />
  </Modal>
}

export default VatRatesAddModal;

